import { action, debug, NetbankingAPI, observable, toJS, UserManagementAPI } from "aaa";
import { AccountsStore } from "stores/AccountsStore";
import { IAccount, IPutAccountResponse } from "types/account";
import { LoginAPIClient, NetbankingAPIClient } from "../../network/APIClient";
import { IConsentsResponse } from "../../types/usermanagement";
import { cloneDeep } from "lodash";

export class TPPStore {
    @observable accountsStore: AccountsStore;
    @observable userManagementConsentsResponse?: IConsentsResponse[];
    @observable loadingConsents = false;
    @observable revoking = false;
    @observable currentConsent?: IConsentsResponse;
    @observable revokingConsent = false;
    @observable defaultAccount?: IAccount;
    @observable newDefaultAccount?: IAccount;
    @observable putAccountResponse?: IPutAccountResponse;

    constructor() {
        this.accountsStore = new AccountsStore();
    }

    isLoading(): boolean {
        return this.loadingConsents
            || this.accountsStore.isLoading;
    }

    @action async load() {
        try {
            this.loadingConsents = true;
            this.userManagementConsentsResponse = await LoginAPIClient.requestType(UserManagementAPI.getConsents());
            await this.accountsStore.load("PSD_2_ACCESS", "psd2Access");

            this.defaultAccount = this.accountsStore.accounts.find(account => account.flags?.includes("defaultPsd2Account"));
            this.newDefaultAccount = this.defaultAccount;

            debug.log("### consents", this.userManagementConsentsResponse);
            this.loadingConsents = false;
        } catch (error) {
            this.loadingConsents = false;
            throw error;
        }
    }

    async revokeConsent(consentId: string) {
        try {
            this.revokingConsent = true;
            const res = await LoginAPIClient.request(UserManagementAPI.deleteConsent(consentId));

            // Now reload
            await this.load();

            debug.log("### revoke consent", res.body);
            this.revokingConsent = false;
        } catch (error) {
            this.revokingConsent = false;
            throw error;
        }
    }

    restoreOriginalDefaultAccount() {
        this.newDefaultAccount = this.defaultAccount;
    }

    @action async updateDefaultAccount() {
        if (!this.newDefaultAccount || this.newDefaultAccount === this.defaultAccount) {
            return;
        }

        try {
            const payload = cloneDeep(toJS(this.newDefaultAccount));
            payload.flags = [...(this.newDefaultAccount.flags ?? []), "defaultPsd2Account"];

            const target = NetbankingAPI.putAccount(this.newDefaultAccount.id, payload);
            this.putAccountResponse = await NetbankingAPIClient.requestType(target);
        } catch (error) {
            throw error;
        }
    }
}




// WEBPACK FOOTER //
// ./src/components/tpp/TPPStore.ts